import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { StorageManager } from '@speeki/storage-manager';

import { openContactSupport } from '@components/organisms/ContactSupportModal/openContactSupport';

import { AppVersionDocument } from '@graphql/generated/graphql';

import { useQuery } from '@apollo/client';

import { FooterLink, FooterWrapper, ReleaseVersion } from './Footer.styled';

export interface FooterProps {
    className?: string;
}

export const Footer = ({ className }: FooterProps) => {
    const { t } = useTranslation();

    const { data } = useQuery(AppVersionDocument);
    const version = data?.version;

    const showAppVersion = !!StorageManager.getValue('tenantUuid');

    return (
        <FooterWrapper className={className}>
            <FooterLink href={'https://speeki.com/'} target={'_blank'}>
                © {dayjs().year()} Speeki Pte Ltd.
            </FooterLink>
            <FooterLink
                href={'https://www.speeki.com/legal-stuff/privacy-policy'}
                target={'_blank'}
            >
                {t('PRIVACY_POLICY')}
            </FooterLink>
            <FooterLink
                aria-haspopup={'dialog'}
                hideLastDivider={!showAppVersion}
                href={'#contact-support'}
                onClick={openContactSupport}
            >
                {t('HELP')}
            </FooterLink>
            {showAppVersion && (
                <ReleaseVersion>
                    {t('VERSION')} {version}
                </ReleaseVersion>
            )}
        </FooterWrapper>
    );
};
